import '../../sass/pages/_authentication.scss'

// IMPORT SERVICES
import { QatarService } from '../services/api';
const api = new QatarService();

// IMPORT COMPONENTS
import Tab from "../components/tab";
import { validate, addedRecoverySection } from "../components/forms";
import FieldValidate from "../components/fieldValidate";
import Popup from "../components/popup";
import { regexEmail } from "../utils/constants";
import { hashUser } from "../components/hashUser"

// IMPORT LIBRARIES
import Swiper, { Navigation } from "swiper";
import "swiper/css";

declare var gsap: any;
declare var ScrollTrigger: any;
declare var Flip: any;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Flip);

declare global {
  interface Window {
    dataLayer: any;
  }
}

const textElements = '.mxbudqtr-forms .mxbudqtr-form-title, .mxbudqtr-forms .mxbudqtr-form-desc'
const formElements = '.mxbudqtr-forms .js-form-item, .mxbudqtr-forms .js-form-type-checkbox, .mxbudqtr-forms .js-form-submit, .mxbudqtr-recovery-password__text, .mxbudqtr-recovery-password__btn'


// Initialize
init()
hiddenTabs()
validateUserInPassionPoint()

// window.addEventListener("load", ()=>{
//   datalayerPassionPoints()
// })


async function init() {
  let verified = await api.checkPassionPoints()


  switch (verified.status) {
    case 401:
      // console.log('Usuario no autenticado');
      break;
    case 404:
      if (!location.pathname.includes('passion')) location.href = '/passion-points'
      break;
    case 200:
      if (!location.pathname.includes('nueva')) location.href = '/perfil'
      break;
  }

  setFieldsState()
  createPassionSwiper()

  let animation: any;
  let field = new FieldValidate('#edit-email', { regex: regexEmail })
  new Popup('#popupValidations', { mainClass: 'mxbudqtr-popup-recovery' })

  new Tab('mxbudqtr', {
    on: {
      initialize(e) {
        let nwGroups = e.nwSection.target.querySelectorAll(`${textElements}, ${formElements}`);
        gsap.to(nwGroups, {
          duration: .8, opacity: 1, pointerEvents: 'all', stagger: .1, translateY: 0, onComplete: () => {
            gsap.set(nwGroups, { clearProps: "transform" })
          }
        });
      },
      activateSection(e) {
        ScrollTrigger.refresh()

        let oldGroups = e.oldSection.target.querySelectorAll(`${textElements}, ${formElements}`);
        let nwGroups = e.nwSection.target.querySelectorAll(`${textElements}, ${formElements}`);

        if (animation) animation.kill()
        gsap.set(oldGroups, { opacity: 0, pointerEvents: 'none', translateY: 30 });
        animation = gsap.to(nwGroups, {
          duration: .8, opacity: 1, pointerEvents: 'all', stagger: .1, translateY: 0, onComplete: () => {
            gsap.set(nwGroups, { clearProps: "transform" })
          }
        })

      }
    }
  });

  setTimeout(() => {
    const passion: boolean = location.pathname.includes('passion');
    const nwPass: boolean = location.pathname.includes('nueva');
    let linkForm = passion ? 'passion' : nwPass ? 'nueva' : false;

    showForm(linkForm)
  }, 300);

  validate()

  let registerForm = document.querySelector('#mx-budweiser-qatar-user-register') as HTMLFormElement;
  registerForm?.addEventListener('bouncerFormValid', async (e) => {
    if (field.exist()) return

    var inputPhone: HTMLInputElement = registerForm.querySelector('input[name=phone]') as any;
    var resPhone = await api.checkPhone(inputPhone.value)
    let jsonResponse = await resPhone.json()

    inputPhone.addEventListener("keydown", function () {
      inputPhone.classList.remove('error')
      inputPhone.nextElementSibling?.remove()
    });

    if (jsonResponse) {
      // console.log(jsonResponse)
      inputPhone.classList.add('error')
      inputPhone.insertAdjacentHTML('afterend', `<span class="error-message">El celular ingresado ya se encuentra registrado</span>`)
      return
    }
    inputPhone.classList.remove('error')
    inputPhone.nextElementSibling?.remove()
    var inputEmail: HTMLInputElement = registerForm.querySelector('input[name=email]') as any;

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Register',
      'event_action': 'Sucess',
      'event_label': 'LoginAPI',
      'userid': hashUser(inputEmail.value), // user id (string)
      'component_name': 'Boton_registro',
      'campaign_description': 'Mundial_Qatar_2022'
    });
    registerForm.submit()
  })
}


// Establece estilos iniciales para luego realizar la animación
function setFieldsState() {
  addedRecoverySection('#mx-budweiser-qatar-user-login #edit-submit', 'beforebegin')
  if (typeof gsap !== "undefined") {
    gsap.set(`${textElements}, ${formElements}`, { opacity: 0, pointerEvents: 'none', translateY: 30 });
  }
  fixedLeftImage()
}

function showForm(passionForm: boolean | string): void {
  // Valida la url y mostrara el correspondiente formulario
  if (typeof passionForm == 'string') {
    switch (passionForm) {
      case 'passion':
        document.querySelector('.mxbudqtr-passion')?.classList.add('mxbudqtr-passion--show')
        break;
      case 'nueva':
        document.querySelector('.mxbudqtr-new-password')?.classList.add('mxbudqtr-new-password--show')
        break;
    }
  }
  else {
    document.querySelector('.mxbudqtr-forms')?.classList.add('mxbudqtr-forms--show')
  }

  // Se oculta el contenedor de los formularios hasta que se conozca cual mostrar
  document.querySelector('.mxbudqtr-authentication__form')?.classList.add('mxbudqtr-authentication__form--loaded')
}

// Ajusta el contenido del lado izquierdo para que quede fijo
function fixedLeftImage(): void {
  ScrollTrigger.matchMedia({
    "(min-width: 991px)": function () {
      ScrollTrigger.create({
        trigger: document.body,
        start: "top top",
        endTrigger: ".mxbudqtr-footer",
        end: "top bottom",
        pin: ".mxbudqtr-authentication__banner-container"
      });
    },
  })
}

// Crea slider para las preguntas de passion points con imagenes
function createPassionSwiper(): void {
  const swipers = document.querySelectorAll('.abi-form__radios .fieldset-wrapper > div')
  for (let i = 0; i < swipers.length; i++) {
    const swiper = swipers[i] as HTMLElement;
    new Swiper(swiper, {
      modules: [Navigation],
      grabCursor: true,
      centerInsufficientSlides: true,
      createElements: true,
      slidesPerView: 'auto',
      spaceBetween: 12,
      slideClass: 'js-form-type-radio',
      navigation: {
        nextEl: `.swiper-button-next-${i}`,
        prevEl: `.swiper-button-prev-${i}`,
      },
      breakpoints: {
        1440: {
          slidesPerView: 5,
          spaceBetween: 12,
        }
      },
      on: {
        beforeInit() {
          swiper.insertAdjacentHTML('afterend', `<div class="swiper-button-next swiper-button-next-${i}"></div>`)
          swiper.insertAdjacentHTML('afterend', `<div class="swiper-button-prev swiper-button-prev-${i}"></div>`)
        },
      }
    })
  }

  observerRadioFields()
}

// Ajusta los mensajes de error de las preguntas con imagenes de los passion points
function observerRadioFields() {
  const targetNode = document.querySelectorAll('.abi-form__radios.fieldgroup')

  const config = { attributes: true, childList: true, subtree: true };

  const observer = new MutationObserver((mutationList: any, observer: any) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        if (mutation.target.classList.contains('error-message')) {
          let fieldWrapper = mutation.target.closest('.fieldset-wrapper')
          let nwError = mutation.target.cloneNode(true)
          fieldWrapper.appendChild(nwError)
        }
        else if (!mutation.target.querySelector('.error-message')) {
          let fieldWrapper = mutation.target.closest('.fieldset-wrapper')
          fieldWrapper.querySelector('.error-message')?.remove()
        }
      }
    }
  });

  for (let i = 0; i < targetNode.length; i++) {
    observer.observe(targetNode[i], config);
  }
}

function hiddenTabs() {
  const tabs = document.querySelector(".mxbudqtr-tab__header") as HTMLElement
  const currentUrl = window.location.pathname;

  if (tabs) {
    if (currentUrl === "/nueva-contrasena") tabs.style.display = "none"
  }
}


function validateUserInPassionPoint() {
  const currentUrl = window.location.pathname;
  if (currentUrl === "/passion-points") {
    if (window.drupalSettings.user.uid <= 0) {
      location.href = "/crear-cuenta";
    }
  }
}